// extracted by mini-css-extract-plugin
export var active = "slider-dots-module--active--oU8B0";
export var button = "slider-dots-module--button--YCn0e";
export var column = "slider-dots-module--column--EcWxF";
export var container = "slider-dots-module--container--MQae5";
export var dot = "slider-dots-module--dot---rJaL";